import { CONTENT_MAX_LENGTH } from '@mais-retorno-front/constants/feeds.constant';

export const cpfFormat = (value: string | number | null): string => {
  if (!value) return;

  return String(value)
    .replace(/[^\d]/g, '')
    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const cellPhoneFormat = (value: string | number | null): string => {
  if (!value) return;

  var checkLength = value.toString();

  return String(value)
    .replace(/[^\d]/g, '')
    .replace(/^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/, `${checkLength.length > 9 ? `($1)` : ''} $2-$3`);
};

export const getOnlyNumber = (text: string) => {
  if (!text) return null;

  return Number(text.replace(/\D/g, ''));
};

export const removeHtml = (text: string) => {
  if (!text) return text;

  return text.replace(/(<([^>]+)>)/gi, '');
};

export const createCanonicalPagination = (
  url: string,
  pageNumber: number
): string => {
  const pagination = pageNumber > 1 ? `/page/${pageNumber}` : '';

  return `${process.env.NEXT_PUBLIC_DOMAIN}${url}${pagination}`;
};

export const getW3CDatefromDate = (date: string) => {
  return date.split('.')[0] || null;
};

export const formatContentToFeeds = (content: string) => {
  if (!content) {
    return null;
  }

  const contentWithoutHtmlTags = removeHtml(content);
  const trimmedContent = contentWithoutHtmlTags.substring(
    0,
    CONTENT_MAX_LENGTH
  );
  const cleanContentFormattedToXMLWithoutCutWord = trimmedContent
    .substring(
      0,
      Math.min(trimmedContent.length, trimmedContent.lastIndexOf(' '))
    )
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('&', '&amp;')
    .replaceAll('\\', '&apos;')
    .replaceAll('"', '&quot;');

  return cleanContentFormattedToXMLWithoutCutWord;
};
